/**
 * Small display helpers shared between IAM rows and the invite dialog.
 *
 * `memberInitials` falls back through first/last → username → email so
 * the avatar tile always has SOMETHING readable even on partially-
 * populated user records.
 */

export const memberInitials = (m) => {
  const first = m?.first_name || '';
  const last  = m?.last_name || '';
  if (first || last) return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase() || 'U';
  const name = m?.username || m?.email || '';
  if (!name) return 'U';
  const parts = name.split(/[\s@._-]+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase();
  return name.slice(0, 2).toUpperCase();
};

export const memberDisplayName = (m) => {
  if (m?.first_name || m?.last_name) {
    return `${m.first_name || ''} ${m.last_name || ''}`.trim();
  }
  return m?.username || m?.email || 'Unnamed user';
};
